<div class="card mt-4">
  <div class="card-body p-4">
    <div class="row g-4">
      <app-form-field class="col-12" label="Tariff type" [includeMargin]="false">
        <app-search
          [options]="specialTariffCodes()"
          [formControl]="specialTariffType"
          [placeholder]="'Type to search'"
          [required]="specialTariffSelected()"
          [inputFormatter]="specialTariffFormatter">
        </app-search>
        @if (specialTariffTypeValue()) {
          <div class="card mt-3">
            <div class="card-body p-3">
              <div>
                {{ formattedSpecialTariffValue() }}
              </div>
            </div>
          </div>
        }
      </app-form-field>
    </div>
    <div class="row mt-3">
      <div class="col-12">
        @if (specialTariffReason.value === null) {
          <button
            type="button"
            class="btn text-primary p-0 text-decoration-none"
            (click)="initRemark()">
            <i class="fa fa-pencil-alt"></i> Add a remark
          </button>
        }

        @else {
          <app-form-field label="Remarks">
            <textarea
              class="form-control"
              [formControl]="specialTariffReason">
            </textarea>
          </app-form-field>
        }
      </div>
    </div>
    @if (specialTariffTypeValue()) {
      <div class="row mt-3">
        <div class="col-12">
          <label class="form-label">Evidence document(s)</label>
          @if (isMissingRequiredEvidence()) {
            <app-alert summary="Evidence document required"
                       icon="fa-circle-xmark"
                       [severity]="AlertSeverity.DANGER"
                       class="mt-2">
              A evidence document is required for this tariff type
            </app-alert>
          }
          <!-- TODO: Replace with file upload component -->
          <div class="text-muted mt-2">Upload functionality will be added here.</div>
        </div>
      </div>
    }
  </div>
</div>
